import { render, staticRenderFns } from "./CreateDocument.vue?vue&type=template&id=69aff3bc&scoped=true&"
import script from "./CreateDocument.vue?vue&type=script&lang=js&"
export * from "./CreateDocument.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocument.vue?vue&type=style&index=0&id=69aff3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aff3bc",
  null
  
)

export default component.exports